var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    fill: "none",
    viewBox: "0 0 28 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#003049",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.832 24.732H8.165c-4.666 0-5.833-1.167-5.833-5.833V9.565c0-4.666 1.167-5.833 5.833-5.833h11.667c4.667 0 5.833 1.167 5.833 5.833V18.9c0 4.666-1.166 5.833-5.833 5.833Zm-3.5-15.167h5.833M17.5 14.232h4.667m-2.335 4.666h2.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#003049",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.916 13.403a2.112 2.112 0 1 0 0-4.223 2.112 2.112 0 0 0 0 4.223Zm4.083 5.881a3.524 3.524 0 0 0-3.197-3.174 8.996 8.996 0 0 0-1.773 0 3.534 3.534 0 0 0-3.197 3.174"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIcon);
export default __webpack_public_path__ + "static/media/contactsIcon.71b41f7a451b295c7f7e3f3d7b81509e.svg";
export { ForwardRef as ReactComponent };